// src/pages/Philosophy.js
import React from "react";
import "../styles/Philosophy.css";

function Philosophy() {
  return (
    <div className="philo-background">
      <div className="philo-container">
        {/*opening text */}
        <div className="philo-content">
          Our mission is to bridge the gap in the manufacturing industry by
          providing reliable staffing solutions and workforce support that help
          businesses grow efficiently. We focus on connecting companies with
          qualified talent while strengthening operational structure and
          accountability.
        </div>
        <div className="philo-row">
          <div className="philo-image">
            <img
              src="/core.png"
              alt="Industry insights"
              className="core-image"
            />
          </div>
          <div className="philo-text">
            Through hands-on experience in roles ranging from general labour to
            management, we identified a growing need for streamlined staffing
            processes, dependable workforce management, and stronger operational
            support within the industry.
          </div>
        </div>
        <div className="philo-row">
          <div className="philo-image">
            <img
              src="/core2.png"
              alt="Industry insights"
              className="core-image"
            />
          </div>
          <div className="philo-text">
            We are committed to enhancing the efficiency of the Canadian
            manufacturing sector, particularly within the Greater Toronto Area,
            by helping businesses build productive teams, improve workforce
            stability, and optimize day-to-day operations.
          </div>
        </div>
        <div className="philo-row">
          <div className="philo-image">
            <img
              src="/core3.png"
              alt="Industry insights"
              className="core-image"
            />
          </div>
          <div className="philo-text">
            Our goal is to support businesses with scalable staffing solutions,
            operational coordination, and additional systems of oversight that
            improve productivity, reliability, and long-term growth.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Philosophy;
